import styled from 'styled-components';

const StyledCommonButtonIconContent = styled.img`
  width: ${props => props?.styles?.iconSize || '15px'};
  height: ${props => props?.styles?.iconSize || '15px'};
`;

export default StyledCommonButtonIconContent;
